import profile from 'routes/Profile/modules';
import modalInformation from 'components/ModalInformation/modules';

export default {
  profile,
  modalInformation,
};



// WEBPACK FOOTER //
// ./src/store/globalState/reducers/conf02.js